import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import frequencyThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
let default_1 = class default_1 extends Vue {
    form;
    type;
    disabled;
    // alertInterval = '600';
    async isValidate() {
        let res = await this.$refs.ruleForm3.isValidate();
        if (res) {
            return true;
        }
    }
};
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Prop({ default: 'FREQUENCY', type: String })
], default_1.prototype, "type", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'FrequencyAndThreshold',
        components: {
            'frequency-and-threshold': frequencyThreshold,
        },
        i18n: {
            messages: {
                zh: {
                    minorCongestion: '轻度拥堵',
                    majorCongestion: '中度拥堵',
                    criticalCongestion: '重度拥堵',
                    minor: '轻度',
                    major: '中度',
                    critical: '重度',
                    level: '等级',
                },
                en: {
                    minorCongestion: 'Minor Congestion',
                    majorCongestion: 'Major Congestion',
                    criticalCongestion: 'Critical Congestion',
                    minor: 'Minor',
                    major: 'Major',
                    critical: 'Critical',
                    level: 'Level',
                },
            },
        },
    })
], default_1);
export default default_1;
